export enum AnalyticType {
  traffic = 'traffic',
  views = 'views',
  dwell = 'dwell',
  attention = 'attention',
  age = 'age',
  gender = 'gender',
  sales = 'sales'
}